import { render, staticRenderFns } from "./docsCreate.vue?vue&type=template&id=a2c93ef8&"
import script from "./docsCreate.vue?vue&type=script&lang=js&"
export * from "./docsCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports